module.exports = "/images/RS.png?5610f97a28a2860e6a9991b9b15b57b1";